import { c as _c } from "react/compiler-runtime";
import { Skeleton } from "@flat-ui";
import { useCreditSettings } from "@hooks/subscription/use-credit-settings";
import { useFetchCompanySubscriptions } from "@hooks/subscription/use-fetch-company-subscriptions";
import { useSubscriptionSettings } from "@hooks/subscription/use-subscription-settings";
import { useUsageMetrics } from "@hooks/subscription/use-usage-metrics";
import { useSeatSettings } from "@hooks/subscription/use-seat-settings";
import { Grid } from "@mui-wrapper";
import { BaseSettingsPage } from "@pages/settings/base-settings-page";
import { NoCredits } from "@pages/settings/subscription-settings/credits/no-credits";
import { allCreditSubscriptionsSelector, isFeatureAvailableInCompanySelector, isFetchingSdbCompanySelector } from "@store/sdb-company/sdb-company-selector";
import { useAppSelector } from "@store/store-helper";

/**
 * Shows the subscription details
 */
export function SubscriptionSettings() {
  const $ = _c(23);
  const isLoading = useAppSelector(isFetchingSdbCompanySelector);
  const {
    subscriptionSectionProps,
    upcomingPlanSectionProps
  } = useSubscriptionSettings();
  const {
    usageSectionProps
  } = useUsageMetrics();
  const {
    seatsSectionProps
  } = useSeatSettings();
  const {
    creditsSectionProps
  } = useCreditSettings();
  const creditSubscriptions = useAppSelector(allCreditSubscriptionsSelector);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = isFeatureAvailableInCompanySelector("floorplan-generator");
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const isFloorplanGeneratorFeatureEnabled = useAppSelector(t0);
  const shouldShowNoTokensSection = isFloorplanGeneratorFeatureEnabled && creditSubscriptions.length === 0;
  useFetchCompanySubscriptions();
  const hasUpcomingPlan = upcomingPlanSectionProps.length > 0;
  let t1;
  if ($[1] !== seatsSectionProps || $[2] !== subscriptionSectionProps || $[3] !== usageSectionProps) {
    t1 = [...subscriptionSectionProps, ...usageSectionProps, ...seatsSectionProps];
    $[1] = seatsSectionProps;
    $[2] = subscriptionSectionProps;
    $[3] = usageSectionProps;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  const currentPlanSections = t1;
  let t2;
  if ($[5] !== creditsSectionProps || $[6] !== currentPlanSections) {
    t2 = [...currentPlanSections, ...creditsSectionProps];
    $[5] = creditsSectionProps;
    $[6] = currentPlanSections;
    $[7] = t2;
  } else {
    t2 = $[7];
  }
  let t3;
  if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = {
      mt: "45px"
    };
    $[8] = t3;
  } else {
    t3 = $[8];
  }
  let t4;
  if ($[9] !== isLoading || $[10] !== t2) {
    t4 = <BaseSettingsPage pageSectionProps={t2} isLoading={isLoading} isCompact={true} dataTestId="workspace-settings-subscription" customSx={t3} />;
    $[9] = isLoading;
    $[10] = t2;
    $[11] = t4;
  } else {
    t4 = $[11];
  }
  let t5;
  if ($[12] !== hasUpcomingPlan || $[13] !== isLoading || $[14] !== upcomingPlanSectionProps) {
    t5 = hasUpcomingPlan && <BaseSettingsPage pageSectionProps={upcomingPlanSectionProps} isLoading={isLoading} isCompact={true} dataTestId="workspace-settings-upcoming-plan" customSx={{
      mt: "80px"
    }} />;
    $[12] = hasUpcomingPlan;
    $[13] = isLoading;
    $[14] = upcomingPlanSectionProps;
    $[15] = t5;
  } else {
    t5 = $[15];
  }
  let t6;
  if ($[16] !== isLoading || $[17] !== shouldShowNoTokensSection) {
    t6 = (isLoading || shouldShowNoTokensSection) && <Grid sx={{
      mt: "45px"
    }}>{isLoading ? <Skeleton variant="rectangular" sx={{
        width: "100%",
        height: "350px"
      }} /> : shouldShowNoTokensSection && <NoCredits />}</Grid>;
    $[16] = isLoading;
    $[17] = shouldShowNoTokensSection;
    $[18] = t6;
  } else {
    t6 = $[18];
  }
  let t7;
  if ($[19] !== t4 || $[20] !== t5 || $[21] !== t6) {
    t7 = <>{t4}{t5}{t6}</>;
    $[19] = t4;
    $[20] = t5;
    $[21] = t6;
    $[22] = t7;
  } else {
    t7 = $[22];
  }
  return t7;
}